// react
import { useEffect, useState } from "react"
// functions
import {status_color_flag} from "../../Suport_functions"
// imgs
import escalera from "./escalera.png"

export default function PlantaBaja({ sala_resaltada, colores }) {
    const [AuditorioBustelo, SetAuditorioBustelo] = useState({ color: colores.color_sala_desactivada, display: "none" })
    const [Explanada, SetExplanada] = useState({ color: colores.color_sala_desactivada, display: "none" })

    useEffect(() => {
        SetAuditorioBustelo(status_color_flag("Auditorio_Accenture", sala_resaltada, colores));
        SetExplanada(status_color_flag("Explanada", sala_resaltada, colores));
    }, [sala_resaltada, colores]);

    return (
        <svg
            id="AuditorioPrincipal"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x={0}
            y={0}
            viewBox="0 0 3370.4 2383.9"
            style={{
                enableBackground: "new 0 0 3370.4 2383.9",
            }}
            xmlSpace="preserve"
        >
            <style>
                {
                    `#AuditorioPrincipal .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#45ac34}
                    #AuditorioPrincipal .st2{fill:#221e73}
                    #AuditorioPrincipal .st3{fill:#fff}
                    #AuditorioPrincipal .st6{fill:${colores.color_sala_desactivada}}
                    #AuditorioPrincipal .st7PlantaBaja{font-family:'Montserrat-SemiBold'}
                    #AuditorioPrincipal .st8{font-size:39.4953px}
                    #AuditorioPrincipal .st11{fill:${AuditorioBustelo.color}}
                    #AuditorioPrincipal .st12{fill:${AuditorioBustelo.color}}
                    #AuditorioPrincipal .st14{font-size:106.1358px}
                    #AuditorioPrincipal .st15{font-size:44.3946px}
                    #AuditorioPrincipal .st16PlantaBaja{fill:none;stroke:#000;stroke-width:6;stroke-linejoin:bevel;stroke-miterlimit:22.9256}`
                }
            </style>
            <g id="explanada">
                <path
                    id="color_explanada_1_"
                    d="m1349 2136.1 552.5-6.7 45.4-.6 72.5-.9-.2-765.3h-1382l-.4-1161.5 1575.2-4.3-.4 327.9c26-14.8 47.8-41.3 63.4-85l74-195.8c30.3-87.1 132-29.8 111.1 41.5l26.6-90.4 65.5-.2L2412.8 601c-30.9 58.2-114.8 45.2-116.8-32l-46.2 117.8h111.6l.9 271 129.5-.7-.4-155.6 704.1 1.7.8 155.6 64-1.1-1.9 430.7h-62.9V1528l-703-.4-.3-142.6-130.8 1.1V1654l-149.8.1v550.2l-942.8 7.9v-21.4l80.5-.9-.3-53.8z"
                    style={{
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        fill: Explanada.color,
                        stroke: "#000",
                        strokeWidth: 6,
                        strokeMiterlimit: 22.9256,
                    }}
                />
                <g id="bandera_explanada" display={Explanada.display}>
                    <path
                        id="palo_1_"
                        d="M2776.1 1092.8c-2-.4-3.2-2.3-2.9-4.3l50.2-264.4c.4-2 2.3-3.2 4.3-2.9 2 .4 3.2 2.3 2.9 4.3l-50.2 264.4c-.3 2-2.3 3.3-4.3 2.9z"
                    />
                    <path
                        id="fondo_bandera_1_"
                        className="st2"
                        d="M3014.2 1014.6c-11.3 2.7-32.1 7.9-53.1-1.3-50.4-21.6-106.8-47-161.5-39.6 8.1-42.9 16.4-85.9 24.5-128.8 72-4.1 144.4 36.4 214.7 40.7-8.4 43.1-16.5 86-24.6 129z"
                    />
                    <path
                        id="borde_bandera_1_"
                        d="M2975.3 1019.9c-8.1-1.4-16.4-4.1-24.7-7.6l-4.1-1.8c-46.5-19.8-94.4-40.2-146.6-33.1-1.1.2-2.3-.2-3.1-1.1-.7-.9-1.1-2-.9-3.2l24.5-128.8c.4-1.6 1.6-2.9 3.4-2.9 40.7-2.3 81.8 9.4 121.4 20.7 31 8.8 63 18 93.8 20 1.1 0 2 .5 2.7 1.4.7.9.9 1.8.7 2.9l-24.5 128.8c-.2 1.3-1.1 2.3-2.3 2.7-12 4.1-25.7 4.8-40.3 2zm-117.8-47.6c31.9 6.1 62.1 18.9 91.8 31.7l4.1 1.8c20.9 9 41.2 11.2 57.5 6.1l23.2-122.6c-30.3-2.5-61.2-11.3-91.1-20-38.2-11-77.6-22.2-116.2-20.7l-23.1 121.2c18.7-2.2 36.5-.9 53.8 2.5zm156.5 42.3z"
                    />
                    <path
                        className="st3"
                        d="M2848.7 914c-.4 1.8-.5 2.7-.9 4.5-7.7-.7-11.5-.7-19.5-.4 1.8-9.7 2.7-14.6 4.7-24.3 7.7-.4 11.5-.2 18.9.4-.4 1.8-.5 2.7-.9 4.5-5.2-.4-7.9-.5-13.1-.5-.4 2.2-.5 3.2-1.1 5.2 4.7 0 7 0 11.7.4-.4 1.8-.5 2.7-.9 4.3-4.7-.4-7-.4-11.7-.4-.4 2.3-.7 3.4-1.1 5.6 5.8.1 8.5.3 13.9.7zM2853.7 918.8c-1.4-.5-2.5-1.1-3.2-1.8 1.1-1.4 1.6-2.2 2.5-3.8.7.5 1.6 1.3 2.9 1.6 1.1.5 2.3.7 3.4.9 2.3.4 3.6 0 3.8-1.3.2-.5-.2-.9-.7-1.3s-1.6-.7-2.9-1.1c-1.4-.4-2.7-.9-3.6-1.3-.9-.4-1.8-1.1-2.3-2-.5-.9-.7-2-.5-3.4.2-1.3.7-2.2 1.6-3.1.9-.9 2-1.4 3.4-1.8s3.1-.4 4.9-.2c1.3.2 2.7.5 4 1.1 1.3.5 2.3 1.1 3.1 1.8-1.1 1.4-1.4 2.2-2.5 3.6-1.4-1.3-3.2-2-5.2-2.3-1.1-.2-2.2-.2-2.7.2-.7.2-1.1.5-1.1 1.1-.2.5.2 1.1.7 1.3.5.4 1.6.7 2.9 1.1 1.4.5 2.7.9 3.6 1.4.9.5 1.6 1.1 2.2 2 .5.9.7 2 .5 3.4-.2 1.1-.7 2.2-1.6 2.9-.9.7-2 1.3-3.4 1.6-1.4.4-3.1.4-4.9 0-1.8.3-3.4 0-4.9-.6zM2882.7 923.5c-.5.2-1.3.4-2.2.4-.7 0-1.6 0-2.5-.4-2.2-.5-3.8-1.4-4.9-2.9-1.1-1.4-1.3-3.2-.9-5.4.5-3.1.9-4.7 1.4-7.7-1.1-.2-1.8-.4-2.9-.5.4-1.6.5-2.5.7-4.1 1.1.2 1.8.4 2.9.5.4-1.8.5-2.7.9-4.5 2.2.4 3.2.7 5.4 1.1-.4 1.8-.5 2.7-.9 4.5 1.8.4 2.7.5 4.7 1.1-.4 1.6-.5 2.5-.7 4.1-1.8-.4-2.7-.7-4.7-1.1-.5 3.1-.9 4.5-1.4 7.6-.2.7 0 1.4.2 2 .4.5.9.9 1.6 1.1.9.2 1.6.2 2.3-.2.5 1.9.7 2.8 1 4.4zM2902.7 912.2c1.3 1.8 1.6 4.1 1.1 6.8-.9 4.3-1.3 6.5-2 10.6-2-.5-3.1-.9-5-1.4.2-.9.2-1.4.4-2.3-1.3 1.4-3.4 1.8-6.1 1.1-1.4-.4-2.5-.9-3.6-1.8-.9-.7-1.6-1.6-2-2.7-.4-1.1-.5-2-.4-3.1.4-1.8 1.3-2.9 2.7-3.6 1.4-.7 3.6-.7 6.3.2 1.6.5 2.5.7 4.3 1.3.2-1.3 0-2.2-.5-3.1-.5-.9-1.6-1.4-3.1-1.8-.9-.2-2-.4-3.1-.4s-2 .4-2.7.7c-.5-1.8-.7-2.5-1.3-4.3 1.1-.5 2.5-.7 4-.7 1.4 0 2.9.2 4.5.5 3.3.9 5.3 2.2 6.5 4zm-7 11.5c.7-.2 1.4-.7 1.8-1.4.2-.7.2-1.1.4-2-1.4-.4-2.2-.5-3.6-1.1-2.2-.5-3.4-.2-3.8 1.3-.2.7 0 1.3.5 1.8s1.1.9 2.2 1.3c.9.4 1.8.4 2.5.1zM2908.5 931.4c-1.4-.9-2.5-1.6-3.2-2.5 1.1-1.3 1.4-2 2.5-3.4.7.7 1.6 1.4 2.7 2.2 1.1.7 2.2 1.3 3.2 1.6 2.2.7 3.4.5 3.6-.7.2-.5-.2-1.1-.7-1.4-.5-.4-1.4-.9-2.7-1.4-1.4-.7-2.7-1.3-3.6-2-.9-.5-1.6-1.4-2.2-2.3-.5-.9-.7-2.2-.5-3.6.2-1.3.7-2.2 1.6-2.9.9-.7 2-1.1 3.4-1.3 1.4-.2 2.9.2 4.7.7 1.3.4 2.5.9 3.8 1.6 1.3.7 2.2 1.4 2.9 2.2-1.1 1.3-1.4 2-2.5 3.2-1.4-1.4-3.1-2.5-5-3.1-1.1-.4-2-.5-2.7-.4-.5.2-1.1.5-1.1.9-.2.5.2 1.1.7 1.4.5.4 1.4.9 2.9 1.6 1.4.7 2.7 1.4 3.6 2 .9.5 1.6 1.4 2.2 2.3.5.9.7 2.2.4 3.6-.2 1.1-.7 2.2-1.6 2.7-.9.7-2 1.1-3.4 1.3-1.4 0-3.1-.2-4.9-.7-1.4-.1-2.9-.8-4.1-1.6zM2951.5 926.9c1.3 1.8 1.6 4.1 1.1 6.8-.9 4.3-1.3 6.5-2 10.6-2-.5-3.1-.9-5-1.4.2-.9.2-1.4.4-2.3-1.3 1.4-3.4 1.8-6.1.9-1.4-.4-2.5-1.1-3.6-1.8-.9-.7-1.6-1.8-2-2.7-.4-1.1-.5-2.2-.2-3.2.4-1.8 1.3-2.9 2.7-3.6 1.4-.5 3.6-.5 6.3.4 1.6.5 2.5.7 4.1 1.3.2-1.3 0-2.2-.5-3.1-.5-.9-1.6-1.4-3.1-1.8-.9-.4-2-.4-2.9-.4-1.1 0-1.8.2-2.7.5-.5-1.8-.7-2.7-1.3-4.3 1.1-.4 2.5-.5 4-.5s2.9.2 4.5.7c2.9.9 5.1 2.1 6.3 3.9zm-7 11.7c.7-.2 1.4-.7 1.8-1.4.2-.7.2-1.1.4-2-1.4-.4-2.2-.7-3.6-1.1-2.2-.7-3.4-.2-3.6 1.3-.2.7 0 1.3.5 2 .5.5 1.1.9 2.2 1.3.7.1 1.6.1 2.3-.1zM2978 931.4c-2 10.3-2.9 15.3-4.9 25.4-2.2-.4-3.2-.5-5.4-1.1.7-3.4 1.1-5.2 1.6-8.6-1.6 1.3-3.6 1.6-5.9 1.1-1.8-.4-3.2-1.3-4.5-2.3s-2.2-2.5-2.7-4.1-.5-3.4-.2-5.4c.4-2 1.1-3.4 2.2-4.7 1.1-1.3 2.3-2.2 4-2.5 1.6-.4 3.2-.4 5 0 2.5.5 4.3 1.8 5.4 3.8.2-.9.2-1.3.4-2.2 1.9.1 3 .3 5 .6zm-9.2 11.9c1.1-.7 1.8-2 2-3.4.4-1.6 0-2.9-.7-4.1-.7-1.1-1.8-1.8-3.1-2.2-1.4-.4-2.5-.2-3.6.5s-1.8 1.8-2 3.4c-.4 1.6-.2 2.9.5 4.1.7 1.1 1.8 2 3.1 2.2 1.7.4 2.7.2 3.8-.5zM3002.1 934.5c-1.4 7.6-2.2 11.2-3.6 18.7-2.2-.2-3.2-.2-5.2-.4.2-.9.2-1.3.4-2.2-.9.7-1.8 1.3-3.1 1.6-1.1.4-2.2.4-3.4.2-2.5-.4-4.3-1.3-5.6-2.9-1.3-1.6-1.4-3.8-.9-6.7.7-4.1 1.3-6.3 2-10.6 2.2.4 3.2.5 5.4.9-.7 4-1.1 5.9-1.8 9.7-.5 3.1.4 4.7 3.1 5 1.3.2 2.5-.2 3.4-.9.9-.7 1.6-2 2-3.6.7-3.8 1.1-5.6 1.8-9.2 2.3.2 3.4.2 5.5.4zM3013.1 927.5c2.3 0 3.6 0 6.1-.2-3.1 2.2-4.5 3.1-7.6 5.2h-4.3c2.4-2.2 3.5-3.1 5.8-5zm-5.7 7.2h5.6c-1.4 7.6-2.2 11.2-3.6 18.7h-5.6c1.4-7.4 2.1-11.2 3.6-18.7z"
                    />
                </g>
            </g>
            <g id="playa-servicios">
                <path
                    id="color_playa"
                    d="M232.5 207.8 113.1 2213.4h885.7l-8.8-276c-158.6-34.1-270.9-93.3-359.8-165.3l-1.9-233.8-134.1-2.1-1.3 68.8-22.3-13.2 2.7-886.3 22.3-7.3.8 65.3 135.1 3.3 5.5-239.3 1.2-9.5-1.4-188.2.1-128.8-404.4 6.8z"
                    style={{
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        fill: colores.color_sala_desactivada,
                        stroke: "#000",
                        strokeWidth: 6,
                        strokeMiterlimit: 22.9256,
                    }}
                />
                <path
                    id="color_servicios"
                    d="M496.4 693.8V767h135.1v39.6h30.7l1.7 269.4-33-.2v147.4h32.9v267.2l-32.8.8v44.9H494v90c-173.1-182.3-233.6-643.8-16.5-928.2 3.3-4.3 11.5-4.1 18.9-4.1"
                    style={{
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        fill: colores.color_sala_desactivada,
                        stroke: "#000",
                        strokeWidth: 6,
                        strokeLinecap: "square",
                        strokeMiterlimit: 22.9256,
                    }}
                />
                <path
                    id="entrada_servicios-playa_2_"
                    className="st6"
                    d="M491.8 698.4h7.4v19.2h-7.4z"
                />
                <path
                    id="entrada_servicios-playa_1_"
                    className="st6"
                    d="M490.7 1582.3h6.2v19.2h-6.2z"
                />
                <path
                    id="entrada_servicios-playa"
                    className="st6"
                    d="M497.9 1531.7h29.2v7.9h-29.2z"
                />
                <text transform="translate(262.413 470.66)" className="st7PlantaBaja st8">
                    {"PLAYA INTERNA"}
                </text>
                <text transform="translate(233.683 518.05)" className="st7PlantaBaja st8">
                    {"ACCESO ARTISTAS "}
                </text>
                <text transform="translate(371.096 1165.616)" className="st7PlantaBaja st8">
                    {"SERVICIOS "}
                </text>
            </g>
            <g id="auditorio-acceso_publico">
                <path
                    id="color_auditorio_1_"
                    d="M629.9 1745.6c90 65.5 234.3 136.2 361.5 161.1l294.2.9c130-35.2 265-103.7 347.2-157.7L1666 1638l-69.2.3 1.2-139.3 74.7.3-4.8-282.9-67.9-.2v-135.1h72.6l-.8-277-74.5.5v-196H636.8l-5.4 198h30.7l1.7 269.4-33-.2v147.4h32.9v267.2l-32.8.8-1 254.4z"
                    style={{
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        fill: AuditorioBustelo.color,
                        stroke: "#000",
                        strokeWidth: 6,
                        strokeMiterlimit: 22.9256,
                    }}
                />
                <path
                    id="color_acceso_publico"
                    d="m1598 671.8-.7 132.9 62.4-.4v276.9H1600v135.1h59.6v282.8H1598l-1.2 139.3 62.4-.3-31.1 132.4c-104.8 81.6-227.7 141.8-379.7 167.9l-292.6 1.6v37.2l-56-.5v125.5h60.1l.8 72.9h38.1v38.5h218.8v-27.2h35.5v-150.9l106.3 11 61.6-42.4h78.4l35.7-50.9 82.1-4.5 13.3-58.5 70.5-14.5 65-55.3 52.2-55.5 50.7-61.3 43.9-66.7 34.6-64.8 32.3-73.4 22.3-69.9 12.7-51.2h-62.1l.4-593-171.3-2.3-.6-89.2-30.7-21.2-152.4-.1z"
                    style={{
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        fill: colores.color_sala_desactivada,
                        stroke: "#000",
                        strokeWidth: 6,
                        strokeMiterlimit: 22.9256,
                    }}
                />
                <path
                    id="entrada_auditorio-playa_1_"
                    transform="matrix(.9999 -.01124 .01124 .9999 -17.768 7.185)"
                    className="st11"
                    d="M625.3 1541.4h10.5v86.8h-10.5z"
                />
                <path
                    id="entrada_auditorio-playa"
                    transform="rotate(-88.441 633.787 715.085) scale(.99997)"
                    className="st11"
                    d="M590.8 710.6h86v8.9h-86z"
                />
                <path
                    id="entrada_acceso_publico-auditotio"
                    className="st12"
                    d="M1655.9 1223.5h55.7V1490h-55.7z"
                />
                <path
                    id="entrada_acceso_publico-auditorio"
                    className="st12"
                    d="M1654.9 809.3h64.3v265.5h-64.3z"
                />
                <path
                    id="entrada_afuera-acceso_publico"
                    style={{
                        fill: colores.color_sala_desactivada,
                    }}
                    d="M1949.6 801.1h42.6v556.6h-42.6z"
                />
                <text transform="translate(810.15 1130.98)" className="st7PlantaBaja st14">
                    {"AUDITORIO "}
                </text>
                <text transform="translate(869.96 1258.34)" className="st7PlantaBaja st14">
                    {"accenture "}
                </text>
                <text transform="translate(1709.435 1146.725)" className="st7PlantaBaja st15">
                    {"ACCESO"}
                </text>
                <text transform="translate(1700.135 1199.995)" className="st7PlantaBaja st15">
                    {"P\xDABLICO"}
                </text>
                <g id="bandera_auditorio_principal" display={AuditorioBustelo.display}>
                    <path
                        id="palo"
                        d="M1163.3 990c-2-.4-3.2-2.3-2.9-4.3l50.2-264.4c.4-2 2.3-3.2 4.3-2.9 2 .4 3.2 2.3 2.9 4.3l-50.2 264.4c-.3 2-2.3 3.3-4.3 2.9z"
                    />
                    <path
                        id="fondo_bandera"
                        className="st2"
                        d="M1401.4 911.8c-11.3 2.7-32.1 7.9-53.1-1.3-50.4-21.6-106.8-47-161.5-39.6 8.1-42.9 16.4-85.9 24.5-128.8 72-4.1 144.4 36.4 214.7 40.7-8.4 43.1-16.5 86-24.6 129z"
                    />
                    <path
                        id="borde_bandera"
                        d="M1362.5 917.1c-8.1-1.4-16.4-4.1-24.7-7.6l-4.1-1.8c-46.5-19.8-94.4-40.2-146.6-33.1-1.1.2-2.3-.2-3.1-1.1-.7-.9-1.1-2-.9-3.2l24.5-128.8c.4-1.6 1.6-2.9 3.4-2.9 40.7-2.3 81.8 9.4 121.4 20.7 31 8.8 63 18 93.8 20 1.1 0 2 .5 2.7 1.4.7.9.9 1.8.7 2.9l-24.5 128.8c-.2 1.3-1.1 2.3-2.3 2.7-12 4.1-25.7 4.9-40.3 2zm-117.8-47.6c31.9 6.1 62.1 18.9 91.8 31.7l4.1 1.8c20.9 9 41.2 11.2 57.5 6.1l23.2-122.6c-30.3-2.5-61.2-11.3-91.1-20-38.2-11-77.6-22.2-116.2-20.7L1191 867c18.6-2.2 36.4-.9 53.7 2.5zm156.5 42.3z"
                    />
                    <path
                        className="st3"
                        d="M1235.9 811.2c-.4 1.8-.5 2.7-.9 4.5-7.7-.7-11.5-.7-19.5-.4 1.8-9.7 2.7-14.6 4.7-24.3 7.7-.4 11.5-.2 18.9.4-.4 1.8-.5 2.7-.9 4.5-5.2-.4-7.9-.5-13.1-.5-.4 2.2-.5 3.2-1.1 5.2 4.7 0 7 0 11.7.4-.4 1.8-.5 2.7-.9 4.3-4.7-.4-7-.4-11.7-.4-.4 2.3-.7 3.4-1.1 5.6 5.8.1 8.5.3 13.9.7zM1240.9 816c-1.4-.5-2.5-1.1-3.2-1.8 1.1-1.4 1.6-2.2 2.5-3.8.7.5 1.6 1.3 2.9 1.6 1.1.5 2.3.7 3.4.9 2.3.4 3.6 0 3.8-1.3.2-.5-.2-.9-.7-1.3-.5-.4-1.6-.7-2.9-1.1-1.4-.4-2.7-.9-3.6-1.3-.9-.4-1.8-1.1-2.3-2-.5-.9-.7-2-.5-3.4.2-1.3.7-2.2 1.6-3.1.9-.9 2-1.4 3.4-1.8 1.4-.4 3.1-.4 4.9-.2 1.3.2 2.7.5 4 1.1 1.3.5 2.3 1.1 3.1 1.8-1.1 1.4-1.4 2.2-2.5 3.6-1.4-1.3-3.2-2-5.2-2.3-1.1-.2-2.2-.2-2.7.2-.7.2-1.1.5-1.1 1.1-.2.5.2 1.1.7 1.3.5.4 1.6.7 2.9 1.1 1.4.5 2.7.9 3.6 1.4s1.6 1.1 2.2 2c.5.9.7 2 .5 3.4-.2 1.1-.7 2.2-1.6 2.9-.9.7-2 1.3-3.4 1.6-1.4.4-3.1.4-4.9 0-1.8.3-3.4 0-4.9-.6zM1269.9 820.7c-.5.2-1.3.4-2.2.4-.7 0-1.6 0-2.5-.4-2.2-.5-3.8-1.4-4.9-2.9-1.1-1.4-1.3-3.2-.9-5.4.5-3.1.9-4.7 1.4-7.7-1.1-.2-1.8-.4-2.9-.5.4-1.6.5-2.5.7-4.1 1.1.2 1.8.4 2.9.5.4-1.8.5-2.7.9-4.5 2.2.4 3.2.7 5.4 1.1-.4 1.8-.5 2.7-.9 4.5 1.8.4 2.7.5 4.7 1.1-.4 1.6-.5 2.5-.7 4.1-1.8-.4-2.7-.7-4.7-1.1-.5 3.1-.9 4.5-1.4 7.6-.2.7 0 1.4.2 2 .4.5.9.9 1.6 1.1.9.2 1.6.2 2.3-.2.5 1.9.7 2.8 1 4.4zM1289.9 809.4c1.3 1.8 1.6 4.1 1.1 6.8-.9 4.3-1.3 6.5-2 10.6-2-.5-3.1-.9-5-1.4.2-.9.2-1.4.4-2.3-1.3 1.4-3.4 1.8-6.1 1.1-1.4-.4-2.5-.9-3.6-1.8-.9-.7-1.6-1.6-2-2.7-.4-1.1-.5-2-.4-3.1.4-1.8 1.3-2.9 2.7-3.6 1.4-.7 3.6-.7 6.3.2 1.6.5 2.5.7 4.3 1.3.2-1.3 0-2.2-.5-3.1-.5-.9-1.6-1.4-3.1-1.8-.9-.2-2-.4-3.1-.4s-2 .4-2.7.7c-.5-1.8-.7-2.5-1.3-4.3 1.1-.5 2.5-.7 4-.7 1.4 0 2.9.2 4.5.5 3.3.9 5.3 2.2 6.5 4zm-7 11.5c.7-.2 1.4-.7 1.8-1.4.2-.7.2-1.1.4-2-1.4-.4-2.2-.5-3.6-1.1-2.2-.5-3.4-.2-3.8 1.3-.2.7 0 1.3.5 1.8s1.1.9 2.2 1.3c.9.5 1.8.5 2.5.1zM1295.7 828.6c-1.4-.9-2.5-1.6-3.2-2.5 1.1-1.3 1.4-2 2.5-3.4.7.7 1.6 1.4 2.7 2.2s2.2 1.3 3.2 1.6c2.2.7 3.4.5 3.6-.7.2-.5-.2-1.1-.7-1.4-.5-.4-1.4-.9-2.7-1.4-1.4-.7-2.7-1.3-3.6-2-.9-.5-1.6-1.4-2.2-2.3-.5-.9-.7-2.2-.5-3.6.2-1.3.7-2.2 1.6-2.9s2-1.1 3.4-1.3c1.4-.2 2.9.2 4.7.7 1.3.4 2.5.9 3.8 1.6 1.3.7 2.2 1.4 2.9 2.2-1.1 1.3-1.4 2-2.5 3.2-1.4-1.4-3.1-2.5-5-3.1-1.1-.4-2-.5-2.7-.4-.5.2-1.1.5-1.1.9-.2.5.2 1.1.7 1.4.5.4 1.4.9 2.9 1.6 1.4.7 2.7 1.4 3.6 2 .9.5 1.6 1.4 2.2 2.3.5.9.7 2.2.4 3.6-.2 1.1-.7 2.2-1.6 2.7-.9.7-2 1.1-3.4 1.3-1.4 0-3.1-.2-4.9-.7-1.4-.1-2.9-.8-4.1-1.6zM1338.7 824.1c1.3 1.8 1.6 4.1 1.1 6.8-.9 4.3-1.3 6.5-2 10.6-2-.5-3.1-.9-5-1.4.2-.9.2-1.4.4-2.3-1.3 1.4-3.4 1.8-6.1.9-1.4-.4-2.5-1.1-3.6-1.8-.9-.7-1.6-1.8-2-2.7-.4-1.1-.5-2.2-.2-3.2.4-1.8 1.3-2.9 2.7-3.6 1.4-.5 3.6-.5 6.3.4 1.6.5 2.5.7 4.1 1.3.2-1.3 0-2.2-.5-3.1-.5-.9-1.6-1.4-3.1-1.8-.9-.4-2-.4-2.9-.4-1.1 0-1.8.2-2.7.5-.5-1.8-.7-2.7-1.3-4.3 1.1-.4 2.5-.5 4-.5 1.4 0 2.9.2 4.5.7 2.9.9 5.1 2.1 6.3 3.9zm-7 11.7c.7-.2 1.4-.7 1.8-1.4.2-.7.2-1.1.4-2-1.4-.4-2.2-.7-3.6-1.1-2.2-.7-3.4-.2-3.6 1.3-.2.7 0 1.3.5 2 .5.5 1.1.9 2.2 1.3.7.1 1.6.1 2.3-.1zM1365.2 828.6c-2 10.3-2.9 15.3-4.9 25.4-2.2-.4-3.2-.5-5.4-1.1.7-3.4 1.1-5.2 1.6-8.6-1.6 1.3-3.6 1.6-5.9 1.1-1.8-.4-3.2-1.3-4.5-2.3-1.3-1.1-2.2-2.5-2.7-4.1-.5-1.6-.5-3.4-.2-5.4.4-2 1.1-3.4 2.2-4.7 1.1-1.3 2.3-2.2 4-2.5 1.6-.4 3.2-.4 5 0 2.5.5 4.3 1.8 5.4 3.8.2-.9.2-1.3.4-2.2 1.9.1 3 .3 5 .6zm-9.2 11.9c1.1-.7 1.8-2 2-3.4.4-1.6 0-2.9-.7-4.1-.7-1.1-1.8-1.8-3.1-2.2-1.4-.4-2.5-.2-3.6.5s-1.8 1.8-2 3.4c-.4 1.6-.2 2.9.5 4.1.7 1.1 1.8 2 3.1 2.2 1.7.4 2.7.2 3.8-.5zM1389.3 831.7c-1.4 7.6-2.2 11.2-3.6 18.7-2.2-.2-3.2-.2-5.2-.4.2-.9.2-1.3.4-2.2-.9.7-1.8 1.3-3.1 1.6-1.1.4-2.2.4-3.4.2-2.5-.4-4.3-1.3-5.6-2.9-1.3-1.6-1.4-3.8-.9-6.7.7-4.1 1.3-6.3 2-10.6 2.2.4 3.2.5 5.4.9-.7 4-1.1 5.9-1.8 9.7-.5 3.1.4 4.7 3.1 5 1.3.2 2.5-.2 3.4-.9.9-.7 1.6-2 2-3.6.7-3.8 1.1-5.6 1.8-9.2 2.3.2 3.4.2 5.5.4zM1400.3 824.7c2.3 0 3.6 0 6.1-.2-3.1 2.2-4.5 3.1-7.6 5.2h-4.3c2.4-2.1 3.5-3 5.8-5zm-5.7 7.2h5.6c-1.4 7.6-2.2 11.2-3.6 18.7h-5.6c1.4-7.4 2.1-11.2 3.6-18.7z"
                    />
                </g>
            </g>
            <g id="explanada-camino_sinuoso">
                <path
                    id="division_camino_sinuoso"
                    className="st16PlantaBaja"
                    d="m2552.1 198.4-137.6 399.5c-9.9 28.6-39.4 45.5-69.1 39.5-29.7-6-50.3-33-48.3-63.3l93.7-276.2"
                />
                <path
                    id="division_camino_sinuoso_1_"
                    className="st16PlantaBaja"
                    d="M2211.6 533.8c21.8-19.5 53.4-53.4 62.1-88.6l74.1-194.7c10.9-34.7 33.6-54.1 68.4-43.3s54.2 47.7 43.5 82.4l-66.4 192"
                />
                <text transform="translate(2720.743 1160.198)" className="st7PlantaBaja st8">
                    {"EXPLANADA"}
                </text>
                <image
                    style={{
                        overflow: "visible",
                        enableBackground: "new",
                    }}
                    width={525}
                    height={475}
                    id="escalera_3_"
                    xlinkHref={escalera}
                    transform="translate(2303.042 1059.399) scale(.4412)"
                />
            </g>
            <g id="boleteria-escenario">
                <path
                    id="color_boleteria"
                    d="m854 455-96.2 153.6h749l-89.4-151.3c-190.9-25.1-378.5-23.5-563.4-2.3z"
                    style={{
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        fill: colores.color_sala_desactivada,
                        stroke: "#000",
                        strokeWidth: 6,
                        strokeMiterlimit: 22.9256,
                    }}
                />
                <path
                    id="separacion_boleteria"
                    d="M638.1 335.6h1207.7H638.1z"
                    style={{
                        fill: "none",
                        stroke: "#000",
                        strokeWidth: 6,
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 22.9256,
                        strokeDasharray: ".43,.22",
                    }}
                />
                <path
                    id="division_escalera"
                    className="st16PlantaBaja"
                    d="M1844.1 580V336.4 580z"
                />
                <text transform="translate(1024.198 537.56)" className="st7PlantaBaja st8">
                    {"ESCENARIO"}
                </text>
                <text transform="translate(1026.848 317.384)" className="st7PlantaBaja st8">
                    {"BOLETER\xCDA"}
                </text>
                <image
                    style={{
                        overflow: "visible",
                        enableBackground: "new",
                    }}
                    width={525}
                    height={475}
                    id="escalera_2_"
                    xlinkHref={escalera}
                    transform="translate(1931.238 323.888) scale(.4412)"
                />
                <image
                    style={{
                        overflow: "visible",
                        enableBackground: "new",
                    }}
                    width={525}
                    height={475}
                    id="escalera_1_"
                    xlinkHref={escalera}
                    transform="translate(654.067 207.955) scale(.2619)"
                />
                <image
                    style={{
                        overflow: "visible",
                        enableBackground: "new",
                    }}
                    width={525}
                    height={475}
                    id="escalera"
                    xlinkHref={escalera}
                    transform="translate(633.01 550.88) scale(.1329)"
                />
                <path
                    id="color_boleteria_1_"
                    d="m960.9 258.2-63.8 78.2h497.1l-59.3-77.1c-126.8-12.8-251.3-11.9-374-1.1z"
                    style={{
                        fill: "none",
                        stroke: "#000",
                        strokeWidth: 3.4884,
                        strokeMiterlimit: 22.9256,
                    }}
                />
            </g>
            <text
                id="titulo"
                transform="translate(541.471 105.417)"
                className="st3 st7PlantaBaja"
                style={{
                    fontSize: "117.8229px",
                }}
            >
                {"PLANTA BAJA / AUDITORIO PRINCIPAL"}
            </text>
            <g id="flecha">
                <text
                    transform="translate(1129.714 2280.44)"
                    className="st3 st7PlantaBaja"
                    style={{
                        fontSize: "32.2043px",
                    }}
                >
                    {"A HALL DE EXPOSICI\xD3N"}
                </text>
                <path
                    style={{
                        fill: "#fff",
                        stroke: "#fff",
                        strokeWidth: 15,
                        strokeMiterlimit: 10,
                    }}
                    d="M1099.8 2190.1v159.1"
                />
                <path className="st3" d="m1099.8 2359.5 43.2-64.8h-86.9z" />
            </g>
        </svg>
    )
}